import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import type { BundleItem } from '../../../../stores/rewards/types';
import { formatValueWithK } from '../../../../utils/helpers';
import { formatNumber } from '../../../../utils/numberFormat';
import { BundleItemsRenderer } from '../../../BundleItemsRenderer/BundleItemsRenderer';
import { SocialCoin } from '../../../SocialCoin/SocialCoin';
import { SweepCoin } from '../../../SweepCoin/SweepCoin';

import styles from './PromoRewardsDisplayV2.module.scss';

type PromoRewardsDisplayProps = {
  gcAmount?: number;
  scAmount?: number;
  bundleItems?: BundleItem[] | null;
  className?: string;
};

export function PromoRewardsDisplay({ gcAmount = 0, scAmount = 0, bundleItems, className }: PromoRewardsDisplayProps) {
  const { t } = useTranslation();
  const hasBundleItems = bundleItems && bundleItems.length > 0;
  const bundleItem = bundleItems?.[0];
  const rewardCount = [gcAmount > 0, scAmount > 0, !!bundleItem?.bundlePayload].filter(Boolean).length;

  return (
    <div className={classNames(styles.promoRewardsDisplay, className)}>
      <div
        className={classNames(styles.prizeCard, {
          [styles.prizeCardWide]: rewardCount >= 3,
          [styles.prizeCardMedium]: rewardCount === 2,
          [styles.prizeCardNarrow]: rewardCount <= 1,
        })}
      >
        <div className={styles.rewardsRow}>
          {gcAmount > 0 && (
            <div className={styles.rewardItem} data-testid="promotion-gift-gc-amount">
              <SocialCoin isPile alt="Crown Coins" className={styles.rewardIcon} />
              <span className={styles.rewardValue}>{formatValueWithK(gcAmount, t)}</span>
            </div>
          )}
          {scAmount > 0 && (
            <div className={styles.rewardItem} data-testid="promotion-gift-sc-amount">
              <SweepCoin isPile alt="Sweepstakes Coins" className={styles.rewardIcon} />
              <span className={styles.rewardValue}>{formatNumber(scAmount)}</span>
            </div>
          )}
          {hasBundleItems && (
            <BundleItemsRenderer
              hidePlus
              bundleItems={bundleItems}
              className={styles.bundleItem}
              dataTestId="promotion-gift-bundle-items"
              direction="vertical-v2"
              frbWidgetWidth={65}
              metagameIconClassName={styles.metagameIcon}
              metagameTextClassName={styles.metagameText}
              metagameTextContainerClassName={styles.metagameTextContainer}
              metaGameWidgetWidth={65}
              wrapperClassName={styles.bundleItemsRow}
            />
          )}
        </div>
      </div>
    </div>
  );
}
